import { mergeDeepRight } from 'ramda';
function styleWrapperFunction(defaultStyle) {
  var overrideStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (typeof defaultStyle === 'function') {
    return function () {
      return mergeDeepRight(defaultStyle(...arguments), typeof overrideStyle === 'function' ? overrideStyle(...arguments) : overrideStyle);
    };
  }
  return mergeDeepRight(defaultStyle, overrideStyle);
}
export function merge(defaultStyleSheet) {
  var overrideStyleSheet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mergedStyleSheets = {};
  for (var [_key, value] of Object.entries(defaultStyleSheet)) {
    var overrideValue = overrideStyleSheet[_key];

    // @ts-expect-error
    mergedStyleSheets[_key] = overrideValue ? styleWrapperFunction(value, overrideValue) : value;
  }
  return mergedStyleSheets;
}
//# sourceMappingURL=merge.js.map